module.exports = __webpack_public_path__ + "static/media/scr_onboarding_logo_android.0ea32373.png";